export default __webpack_public_path__ + "static/bestdoctors-5d77e3b1e39d2347865812e71151df52.jpg";